export default "__VITE_ASSET__D9L0ubDx__"